import {useEffect, useState} from "react";
import {Link} from "react-router-dom";
import {getFromApi, postToApi, patchToApi, deleteFromApi} from "../api/auth";
import InlineRename from "../components/shared/InlineRename";
import ConfirmButton from "../components/shared/ConfirmButton";

export default function Todo() {
    const [groups, setGroups] = useState([]);
    const [name, setName]     = useState("");
    const [loading, setLoading] = useState(true);

    const load = async () => {
        try {
            const res = await getFromApi("api/todo");
            setGroups(res.data || []);
        } finally { setLoading(false); }
    };

    useEffect(() => { load(); }, []);

    const handleAdd = async (e) => {
        e.preventDefault();
        await postToApi("api/todo", {name});
        setName(""); load();
    };

    const handleRename = async (id, newName) => {
        await patchToApi(`api/todo/${id}`, {name: newName});
        load();
    };

    const handleDelete = async (id) => {
        await deleteFromApi(`api/todo/${id}`);
        load();
    };

    const formatDue = (due) => {
        if (!due) return null;
        const d = new Date(due);
        const today = new Date(); today.setHours(0,0,0,0);
        const diff = Math.ceil((d - today) / 86400000);
        if (diff < 0)  return {label: `${Math.abs(diff)}d overdue`, color: "#ef4444"};
        if (diff === 0) return {label: "Due today", color: "#f59e0b"};
        if (diff === 1) return {label: "Due tomorrow", color: "#f59e0b"};
        return {label: `Due ${d.toLocaleDateString(undefined,{day:"numeric",month:"short"})}`, color: "#6b7280"};
    };

    return (
        <div>
            <div className="page-header">
                <h4><i className="bi bi-check2-square me-2 text-success"/>Todo Lists</h4>
            </div>

            <div className="panel mb-4">
                <form onSubmit={handleAdd} className="row g-2 align-items-end">
                    <div className="col-md-9">
                        <label className="form-label small fw-medium">New list</label>
                        <input className="form-control" placeholder="e.g. Work tasks" value={name} onChange={e => setName(e.target.value)} required/>
                    </div>
                    <div className="col-md-3">
                        <button type="submit" className="btn btn-dark w-100"><i className="bi bi-plus-lg me-1"/>Create</button>
                    </div>
                </form>
            </div>

            {loading ? <div className="text-muted text-center py-4">Loading...</div> : (
                <div className="panel p-0" style={{overflow:"hidden"}}>
                    {groups.map((g, i) => {
                        const due = formatDue(g.nextDue);
                        return (
                            <div key={g._id} className={`d-flex align-items-center justify-content-between px-4 py-3 ${i<groups.length-1?"border-bottom":""}`}>
                                <div>
                                    <InlineRename value={g.name} onSave={name => handleRename(g._id, name)} className="fw-medium"/>
                                    {due && <div className="small mt-1" style={{color: due.color}}><i className="bi bi-clock me-1"/>{due.label}</div>}
                                </div>
                                <div className="d-flex align-items-center gap-2">
                                    <Link to={`/todo/${g._id}`} className="btn btn-sm btn-outline-secondary">Open</Link>
                                    <span className="badge rounded-pill text-bg-success">{g.completed} done</span>
                                    <span className="badge rounded-pill text-bg-warning text-dark">{g.uncompleted} left</span>
                                    <ConfirmButton className="btn btn-sm btn-outline-danger" onConfirm={() => handleDelete(g._id)}>
                                        <i className="bi bi-trash"/>
                                    </ConfirmButton>
                                </div>
                            </div>
                        );
                    })}
                    {!groups.length && (
                        <div className="empty-state">
                            <i className="bi bi-clipboard-check"/>
                            <div>No lists yet.</div>
                        </div>
                    )}
                </div>
            )}
        </div>
    );
}
